import React from "react";

import logo from "../assets/zeos-ai-blue-logo.png";
import {
  contentWrapperClass,
  ZeosFontSize,
} from "../services/helpers/ThemeHelpers";

interface IProps {
  title: string;
  message?: string;
  content: React.ReactNode;
  contentType: "form" | "display" | "other";
}

export const AnonymousLayout = (props: IProps) => {
  return (
    <div id="page-container" className="min-h-screen bg-zeos-grey-lt">
      {/* Logo Header */}
      <div className="bg-zeos-white flex justify-center h-[80px]">
        <div className="w-full max-w-[1140px] flex items-center px-6">
          <img src={logo} className="h-[40px]" alt="ZEOS-AI logo" />
        </div>
      </div>

      {/* Content Container */}
      <div className="w-full max-w-[1140px] mx-auto px-6 py-8">
        {/* Page Title + Message */}
        <div id="message-region" className="mb-6 space-y-3">
          <p className={`text-${ZeosFontSize.xxxl} leading-snug`}>
            {props.title}
          </p>
          {props.message && (
            <p className={`text-${ZeosFontSize.xl} leading-relaxed`}>
              {props.message}
            </p>
          )}
        </div>

        {/* Main Content Card */}
        <div className="bg-zeos-white shadow rounded p-6">
          <div className={contentWrapperClass(props.contentType)}>
            {props.content}
          </div>
        </div>
      </div>
    </div>
  );
};
